/**
 * Canonical slug validation and normalization.
 * Used for producer slugs and any future entity slugs.
 */

const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

/** Validate a slug string. Returns null if valid, or a Swedish error message. */
export function validateSlug(slug: string): string | null {
  if (!slug) return 'Sidans adress får inte vara tom.';
  if (slug.length < 2) return 'Adressen måste vara minst 2 tecken.';
  if (slug.length > 80) return 'Adressen får vara max 80 tecken.';
  if (!SLUG_REGEX.test(slug)) {
    return 'Adressen får bara innehålla små bokstäver (a–z), siffror och bindestreck.';
  }
  return null;
}

/**
 * Normalize user input to a slug-friendly string.
 * Transliterates Swedish characters (å→a, ä→a, ö→o),
 * trims, lowercases, replaces spaces/underscores with hyphens,
 * strips invalid characters, and collapses repeated hyphens.
 */
export function normalizeSlug(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/å/g, 'a')
    .replace(/ä/g, 'a')
    .replace(/ö/g, 'o')
    .replace(/é/g, 'e')
    .replace(/[\s_]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-{2,}/g, '-')
    .replace(/^-+|-+$/g, '');
}
